
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getIsShowList, getBannerImageList, getIconNavigationList, getActivityGoodsList, getActivityDtlGoodsList } from '@/api/industryMall'
import { getIsAfterTime } from '@/utils/util'
import NoticeBar from '@/components/NoticeBar/index.vue'
import CountDown from '@/views/industryMall/shop/template/countDown.vue'
import dayjs from 'dayjs'

export class ActivityDTO {
  activityId?: string // 活动id
  showBanner?: number // 是否显示轮播图
  showIconNavigation?: number // 是否显示图标导航
  showActivity?: number // 是否显示活动
  showBannerTime?: number // 轮播图间隔时间
}
@Component({
  components: { NoticeBar, CountDown }
})
export default class ActivitySegment extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string //合作方公司编号
  carouselList: Array<any> = []
  navList: Array<any> = []
  activityList: Array<any> = []
  data: ActivityDTO = {}
  activityData: any = {}
  countDownTime = ''
  isStart = false
  showData = {
    isAfterAdvance: false, // 是否过了提前展示时间
    isAfterBegin: false, // 是否过了开始时间
    isAfterEnd: false // 是否过了结束时间
  }

  get countDownTimeText () {
    if (this.showData.isAfterAdvance && !this.showData.isAfterBegin) {
      return '距开始'
    } else {
      return '距结束'
    }
  }

  // 获取最小价格
  getMinData (goodsData: any) {
    let minPrice = 1000000
    let saleUnitWay = ''
    goodsData.packageList.map((item, index) => {
      // let price = Number(item.marketPrice) / item.sellUnit
      let price = Number(item.finalPrice) / item.sellUnit

      if (price < minPrice) {
        minPrice = price
        saleUnitWay = item.sellUnitWay
      }
    })
    let textPrice = minPrice.toFixed(2)
    return { minPrice: textPrice, saleUnitWay }
  }

  // 刷新数据
  refresh () {
    this.getIsShow()
    this.$refs.notice && (this.$refs.notice as any).getPartnerCompanyNoticeInfo()
  }

  created () {
    this.getIsShow()
  }

  getIsShow () {
    const { partnerCompanyId } = this
    // 获取模块是否展示
    getIsShowList({ partnerCompanyId }).then(res => {
      this.data = res.data
      this.$emit('data', this.data)
      this.initData()
    })
  }

  initData () {
    const { partnerCompanyId, companyId } = this
    // 获取轮播图
    this.data.showBanner && getBannerImageList({ partnerCompanyId, companyId }).then(res => {
      this.carouselList = res.data
    })
    // 获取图标导航
    this.data.showIconNavigation && getIconNavigationList({ partnerCompanyId }).then(res => {
      this.navList = res.data
    })
    // 获取活动是否开始
    this.data.showActivity && this.getActivityIsStart()
  }

  // 获取活动是否开始
  getActivityIsStart () {
    this.data.activityId && getActivityGoodsList({ activityId: this.data.activityId }).then(res => {
      // 活动详情数据
      this.activityData = res.data[0]
      // 是否提前展示
      this.showData = getIsAfterTime(this.activityData)
      if (this.activityData.timeType) { // 自定义时间段
        if (this.showData.isAfterAdvance && !this.showData.isAfterBegin) { // 距离开始时间
          this.countDownTime = this.activityData.beginTime
        } else if (this.showData.isAfterBegin) { // 距离结束时间
          this.isStart = true
          this.countDownTime = this.activityData.closeTime
        }
      } else { // 每天时间段
        if (this.showData.isAfterAdvance && !this.showData.isAfterBegin) {
          this.countDownTime = `${dayjs().format('YYYY-MM-DD')} ${this.activityData.startTime}`
        } else if (this.showData.isAfterBegin) {
          this.isStart = true
          this.countDownTime = `${dayjs().format('YYYY-MM-DD')} ${this.activityData.endTime}`
        }
      }
      // 获取活动商品列表
      this.showData.isAfterAdvance && !this.showData.isAfterEnd && getActivityDtlGoodsList({
        activityId: this.data.activityId,
        categoryId: '',
        pageIndex: 1,
        pageSize: 4,
        companyId: this.companyId,
        partnerCompanyId: this.partnerCompanyId
      }).then(res => {
        this.activityList = res.data.records
      })
    })
  }

  // 点击轮播图
  bannerClick (banner: any) {
    // showType: 1代表商品 0代表仅展示
    if (banner.showType) {
      this.$router.push({
        path: '/goodsMallDetail',
        query: {
          goodsId: banner.goodsId,
          storeId: banner.storeId
        }
      })
    }
  }

  // 点击图标导航
  goToCategory (category: any) {
    console.log(`category *** ${JSON.stringify(category)}`)
    if (category.categoryLevel > 0) {
      this.$router.push({ path: '/mallCategory', query: { isHome: 'home', categoryId: category.categoryId }})
    } else {
      if (this.data.showActivity) this.moreActivityGoods(category.categoryId)
    }
  }

  // 活动商品
  goToActivityGoods (goods: any) {
    this.$router.push({
      path: '/goodsMallDetail',
      query: {
        goodsId: goods.goodsId,
        storeId: goods.storeId
      }
    })
  }

  // 更多活动
  async moreActivityGoods(categoryId?: string) {
    await this.getActivityIsStart()
    this.$router.push({
      path: '/activity',
      query: { activityId: this.data.activityId, isStart: this.showData.isAfterAdvance ? '1': '0', categoryId: categoryId || '' }
    })
  }
}
